if (!customElements.get('fc-accordion')) {
  class FcAccordion extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.triggers = this.querySelectorAll('.fc-accordion__trigger');
      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', this.handleToggle.bind(this));
      });
    }

    handleToggle(event) {
      const trigger = event.currentTarget;
      const item = trigger.closest('.fc-accordion__item');
      if (!item) return;

      const body = item.querySelector('.fc-accordion__body');
      if (!body) return;

      const isOpen = trigger.getAttribute('aria-expanded') === 'true';

      if (isOpen) {
        this.close(item, trigger, body);
      } else {
        this.open(item, trigger, body);
      }
    }

    open(item, trigger, body) {
      trigger.setAttribute('aria-expanded', 'true');
      body.setAttribute('aria-hidden', 'false');
      item.classList.add('is-open');

      body.style.maxHeight = body.scrollHeight + 'px';

      body.addEventListener('transitionend', function handler() {
        body.style.maxHeight = 'none';
        body.removeEventListener('transitionend', handler);
      });
    }

    close(item, trigger, body) {
      body.style.maxHeight = body.scrollHeight + 'px';
      body.offsetHeight; /* force reflow */

      requestAnimationFrame(() => {
        body.style.maxHeight = '0';
        trigger.setAttribute('aria-expanded', 'false');
        body.setAttribute('aria-hidden', 'true');
        item.classList.remove('is-open');
      });
    }
  }

  customElements.define('fc-accordion', FcAccordion);
}
